import { t } from 'localization/utils/t';
import { getRedirectionPath } from 'localization/utils/getRedirectionPath';
import { getLocale } from 'shared/utils/getLocale';

const TP = 'shared.utils.linkCollectionDescriptionToGiftCard';

// Temporary solution for ticket COMM-16 until mobile apps can support html link
// since CMS provides the same description for all platforms
export const linkCollectionDescriptionToGiftCard = (description: string) => {
  if (!description) {
    return;
  }

  const linkLabel = t(`${TP}.linkLabel`, 'Shop GOAT Gift Cards');

  if (description?.toLowerCase()?.includes(linkLabel.toLowerCase())) {
    const locale = getLocale();
    const reg = new RegExp(linkLabel, 'i');
    const link = getRedirectionPath('/gift-cards', locale);
    return description.replace(reg, `<a href="${link}">${linkLabel}</a>`);
  }

  return description;
};
